module.exports = "images/enfants_9.8367fb1a.png";